module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Size-daef96bcb32e4cf16eb8837c3b73ff1c.svg";